import Vue from 'vue';
import App from './App.vue';
import router from './router';
import {builder} from './store'
import Vuex from "vuex"


Vue.config.productionTip = false;

Vue.use(Vuex)

new Vue({
  router,
  store: builder.vuexStore(),
  render: (h) => h(App),
}).$mount('#app');
